import { Address } from "./address";
import { BaseProperties } from "./base.interface";
import { OrderDeliveryType } from "./orders";

export enum PreOrderStatus {
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
}

export enum PreOrderPaymentMethod {
  CASH = "CASH",
  CREDIT_CARD = "CREDIT_CARD",
  DEBIT_CARD = "DEBIT_CARD",
  PIX = "PIX",
}

export interface PreOrderCustomer {
  customerId?: string;
  name: string;
  internationalCode?: string;
  ddd?: string;
  phoneNumber?: string;
}

export interface PreOrderDelivery {
  deliveryType: OrderDeliveryType;
  deliveryValue?: number;
  deliveryAt?: Date;
  address?: Address;
}

export interface PreOrderAdditional {
  additionalId: string;
  itemId: string;
  name?: string;
  unitPrice: number;
  unitCost: number;
  quantity: number;
}

export interface PreOrderSubItem {
  itemId: string;
  name: string;
  fileId?: string | null;
  unitPrice: number;
  unitCost: number;
  quantity: number;
  additionals: PreOrderAdditional[];
}

export interface PreOrderItem {
  quantity: number;
  kind: "OFFER" | "PRODUCT";
  offerId?: string;
  productId?: string;
  name: string;
  description?: string;
  observation?: string | null;
  fileId?: string | null;
  unitPrice: number;
  unitCost: number;
  items?: PreOrderSubItem[];
  additionals: PreOrderAdditional[];
}

export interface PreOrderOutput extends BaseProperties {
  code?: string;
  menuId: string;
  paymentMethod: PreOrderPaymentMethod;
  customer: PreOrderCustomer;
  delivery: PreOrderDelivery;
  observation?: string;
  items: PreOrderItem[];
  /** Valor de imposto calculado automaticamente */
  tax?: number;
  totalAmount?: number;
  status: PreOrderStatus;
  userId?: string;
}

export interface PreOrderQueryParams {
  status?: PreOrderStatus;
  code?: string;
  expand?: string | string[];
  page?: number;
  pageSize?: number;
}
